import { initialApprovals } from '../../mocks/dashboard';

/**
 * Approval queue slice. `initialApprovals` (mocks/dashboard.js) is the sample
 * seed; useApprovals() fetches GET /api/approvals on mount and swaps in the
 * server queue on success (`approvalsMode: 'live'`). Mock seed + 'sample'
 * remains whenever the fetch fails — no silent fallback (go-live-readiness
 * §1/§5c2).
 *
 * Keys are namespaced (`approvalsMode`, not `mode`): slices merge into one
 * Zustand store and a bare `mode` here would collide with agentsSlice's.
 */
export const createApprovalsSlice = (set) => ({
  approvals: initialApprovals,
  approvalsMode: 'sample',
  selectedApprovalId: initialApprovals[0]?.id,

  setApprovals: (list, mode) => set((state) => ({
    approvals: Array.isArray(list) ? list : state.approvals,
    approvalsMode: mode === 'live' ? 'live' : 'sample',
    // Selection can only point at rows we actually hold.
    selectedApprovalId: Array.isArray(list)
      ? list.find((approval) => approval.id === state.selectedApprovalId)?.id ?? list[0]?.id ?? null
      : state.selectedApprovalId
  })),

  setApprovalsMode: (mode) => set({
    approvalsMode: mode === 'live' ? 'live' : 'sample'
  }),

  setSelectedApproval: (selectedApprovalId) => set({ selectedApprovalId }),

  // Snapshot/rollback contract for the optimistic queue
  // (features/approvals/optimistic.js): apply hides the row, rollback puts it
  // back verbatim, commit drops the snapshot.
  removeApproval: (id) => set((state) => ({
    approvals: state.approvals.filter((approval) => approval.id !== id),
    selectedApprovalId: state.approvals.find((approval) => approval.id !== id)?.id
  })),

  restoreApproval: (approval) => set((state) => ({
    approvals: [...state.approvals, approval]
  })),

  approveApproval: (id) => set((state) => ({
    approvals: state.approvals.filter((approval) => approval.id !== id)
  })),

  rejectApproval: (id) => set((state) => ({
    approvals: state.approvals.filter((approval) => approval.id !== id)
  })),

  modifyApproval: (id) => set((state) => ({
    approvals: state.approvals.map((approval) => (
      approval.id === id
        ? { ...approval, status: 'modified' }
        : approval
    ))
  }))
});
